import { cn } from "helpers/classNames";
import { FC } from "react";

interface Props {
  size?: number;
  className?: string;
  color?: "blue" | "red" | "amber";
}
export const Dot: FC<Props> = ({ size = 3, className, color = "blue" }) => (
  <div className={cn(`relative ml-2 h-3 w-3`, className)}>
    <span className={`flex h-3 w-3`}>
      <span
        className={cn(
          `relative inline-flex rounded-full h-${size} w-${size}`,
          color === "blue" && "bg-cyan-400",
          color === "red" && "bg-rose-400",
          color === "amber" && "bg-amber-500",
        )}
      ></span>
    </span>
  </div>
);
